import { CircularProgress, Tooltip } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
export const Suggestions = ({
  isLoading,
  onAccept,
  onReject,
  suggestedData,
}) => {
  return (
    <div className="border border-slate-200 rounded-lg p-4 absolute top-20 backdrop-blur-md bg-white/30 w-full">
      <div className="flex justify-between">
        <p className="font-bold">Suggestions:</p>
        {!isLoading && suggestedData && (
          <div className="text-slate-400 flex">
            <Tooltip title="Accept" arrow placement="top">
              <div onClick={onAccept}>
                <DoneIcon className="hover:text-[#3cc3aa] cursor-pointer" />
              </div>
            </Tooltip>
            <Tooltip title="Ignore" arrow placement="top">
              <div onClick={onReject}>
                <CloseIcon className="hover:text-[#c34c3c] cursor-pointer" />
              </div>
            </Tooltip>
          </div>
        )}
      </div>
      {!isLoading ? (
        !suggestedData ? (
          <Subtitle>
            No suggestions found.Please try again using different description
          </Subtitle>
        ) : (
          <div>
            <p className="font-bold">Appearance</p>
            <p className="mb-2 text-sm">{suggestedData?.visual_description}</p>
            <p className="font-bold">Typical Clothing</p>
            <p className="mb-2 text-sm">{suggestedData?.typical_clothing}</p>
            <p className="font-bold">Typical Expression</p>
            <p className="mb-2 text-sm">{suggestedData?.typical_expression}</p>
          </div>
        )
      ) : (
        <center className="p-8">
          <CircularProgress size={22} />
        </center>
      )}
    </div>
  );
};
